import React from "react";
import { Link } from "react-scroll";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <Link to="herosection" smooth={true} duration={500} className="footer-brand">
          <img className="footer-logo" src={`${process.env.PUBLIC_URL}/images/of_logo.png`} alt="Orifril" />
          <span>Orifril Lifetech</span>
        </Link>
        <div className="footer-social-icons">
          <a href="https://www.facebook.com/profile.php?id=61571274574857" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-square-facebook fa-xl"></i>
          </a>
          <a href="https://www.linkedin.com/company/orifril-lifetech-private-limited/" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-linkedin fa-xl"></i>
          </a>
          <a href="https://www.instagram.com/orifril_lifetech/" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-square-instagram fa-xl"></i>
          </a>
        </div>
        <p className="footer-copyright-text">
          <i class="fa-regular fa-copyright"></i> 2024 Orifril Lifetech Pvt Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;